import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ServicioNotasEnfermeriaService, EntidadEmpresarial, ParametrosNotasEnfermeriaEntity } from 'src/app/services/servicio-notas-enfermeria.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-notas-enfermeria',
  templateUrl: './header-notas-enfermeria.component.html',
  styleUrls: ['./header-notas-enfermeria.component.css']
})
export class HeaderNotasEnfermeriaComponent implements OnInit {

  loading: boolean;
  fechaInicial: Date;
  fechaFinal: Date;
  downloading: boolean;
  canDownload: boolean;

  @Input() public uncoEntidad: number;
  @Input() public objetoParametrosEntity: ParametrosNotasEnfermeriaEntity;
  @Output() entidadEmpresarial: EventEmitter<EntidadEmpresarial>;

  constructor(private servicioNotasEnfermeriaService: ServicioNotasEnfermeriaService) {
    this.loading = true;
    this.entidadEmpresarial = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }
  init() {
    this.getEntidadEmpresarial();
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioNotasEnfermeriaService.getEntidadEmpresarial(this.objetoParametrosEntity, this.uncoEntidad);
      if (response != null) {
        response.subscribe((data: any) => {

          const entidad: EntidadEmpresarial = {
            unco: data.unco,
            nombreEntidad: data.dscrpcn_entdd_emprsrl,
            nit: data.idntfccn_trbtra,
            digitoVerificacion: data.dgto_vrfccn,
            direccion: data.drccn,
            telefono: data.tlfno_pbx,
          };
          this.entidadEmpresarial.emit(entidad);

        }, (err: HttpErrorResponse) => {
          console.log('Error sede', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('Error en datos entidad empresarial: ' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  onGenerar() {

  }

  onDescargarExcel() {

  }

}
